import React, { useContext } from 'react'
import { flowRight } from 'lodash'
import { useTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { USL } from 'lib/alma/alma'
import { getLocale } from 'lib/utils/getLocale'

import useVerticalBackUrl from 'components/Navigation/VerticalBackLink/useVerticalBackUrl'
import { AppHeaderContext } from 'components/AppHeader/AppHeader'
import AppHeaderMobileLogo from 'components/AppHeader/AppHeaderMobile/AppHeaderMobileLogo/AppHeaderMobileLogo'
import AppHeaderMobileUserNav from 'components/AppHeader/AppHeaderMobile/AppHeaderMobileUserNav/AppHeaderMobileUserNav'
import AppHeaderMarketsNav from 'components/AppHeader/AppHeaderMarketsNav/AppHeaderMarketsNav'
import AppHeaderMobileVerticalBack from './AppHeaderMobileVerticalBack/AppHeaderMobileVerticalBack'
import Icon from 'components/Icon'
import AppHeaderInboxNav from 'components/AppHeader/AppHeaderInboxNav/AppHeaderInboxNav'
import AppHeaderMobileVerticalNav from './AppHeaderMobileVerticalNav/AppHeaderMobileVerticalNav'
import Link from 'components/Link'
import AuthLoginButton from 'components/Auth/AuthLoginButton/AuthLoginButton'
import AuthLogoutButton from 'components/Auth/AuthLogoutButton/AuthLogoutButton'
import LoadingIndicator from 'components/LoadingIndicator'
import { AuthContext } from 'components/Auth/Auth'

import './app-header-mobile.pcss'

const AppHeaderMobile = ({ className }) => {
    const auth = useContext(AuthContext)
    const { loggedIn, currentUserLoading } = useContext(AppHeaderContext)
    const verticalBack = useVerticalBackUrl()

    const { t, i18n } = useTranslation()

    return (
        <header className={classNames('app-header-mobile', className)}>
            <div className="app-header-mobile__top">
                <AppHeaderMobileVerticalBack />
                {!verticalBack && (
                    <div className="app-header-mobile__branding">
                        <AppHeaderMobileLogo />
                        <AppHeaderMobileVerticalNav />
                    </div>
                )}
                <div className="app-header-mobile__right">
                    {(currentUserLoading || auth.almaLoading) ? (
                        <LoadingIndicator type="plain" loaderType="header" />
                    ) : (
                        loggedIn ? (
                            <AppHeaderMobileUserNav />
                        ) : (
                            <div className="app-header-mobile__user-login">
                                {auth.almaAuthData?.user ? (
                                    <AuthLogoutButton />
                                ) : (
                                    <AuthLoginButton
                                        userSourceLabeling={{
                                            source: USL.SOURCE.navigation_topmenu_login,
                                            type: USL.TYPE.permanent,
                                        }}
                                    >
                                        <Icon name="icon_user_white" size="m" />
                                        <span>{t('common:login.cta.login')}</span>
                                    </AuthLoginButton>
                                )}
                            </div>
                        )
                    )}
                </div>
            </div>
            {loggedIn ? (
                <div className="app-header-mobile__bottom">
                    <div className="app-header-mobile__bottom-links">
                        <Link
                            exact
                            to={`${getLocale(i18n.language) || '/'}`}
                            title={t('common:navigation.myVehicles')}
                            trackName="myVehicles"
                        >
                            {t('common:navigation.myVehicles')}
                        </Link>
                        <AppHeaderInboxNav />
                        <AppHeaderMarketsNav />
                    </div>
                </div>
            ) : (
                <div className="app-header-mobile__bottom">
                    <div className="app-header-mobile__bottom-links">
                        <Link
                            exact
                            to={`${getLocale(i18n.language) || '/'}`}
                            title={t('common:navigation.myVehicles')}
                            trackName="myVehicles"
                        >
                            {t('common:navigation.myVehicles')}
                        </Link>
                        <Link
                            to={`${getLocale(i18n.language)}/fiksut-kaupat`}
                            title={t('common:navigation.billOfSale')}
                            trackName="bosList"
                        >
                            {t('common:navigation.markets')}
                        </Link>
                    </div>
                </div>
            )}
        </header>
    )
}

AppHeaderMobile.propTypes = {
    className: PropTypes.string.isRequired,
}

export default flowRight(
    withRouter,
)(AppHeaderMobile)
